<template>
  <div class="graphic-list-item">
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
        v-if="list.length > 0"
        :offset="100"
      >
        <van-cell v-for="item in list" :key="item.id" @click="jump2article(item)">
          <ListItemCard :title="item.title" :img="item.imgUrl" :max-line="2">
            <template #desc>
              <div class="desc">
                <span>{{ item.visitTimes }}人正在学习</span>
              </div>
            </template>
          </ListItemCard>
        </van-cell>
      </van-list>
      <!-- todo无数据的状态 -->
      <EmptyBlock v-else-if="!loading" description="暂无数据"></EmptyBlock>
    </van-pull-refresh>
  </div>
</template>

<script>
import { encyclopediaEntryPage } from '@/services';

export default {
  props: ['tabDetail', 'active'],

  data() {
    return {
      list: [],
      loading: false,
      finished: false,

      params: {
        parentId: '',
        pageSize: 20,
        pageNo: 0
      }
    };
  },
  mounted() {
    this.params.parentId = this.tabDetail.id;
    this.onLoad();
  },
  methods: {
    async getTabList() {
      this.loading = true;
      const { dataList } = await encyclopediaEntryPage(this.params);
      this.loading = false;
      return dataList;
    },

    async onRefresh() {
      this.finished = false;
      this.params.pageNo = 1;
      const list = await this.getTabList();
      this.list = list;
    },

    async onLoad() {
      this.params.pageNo += 1;
      const list = await this.getTabList();
      this.list = this.list.concat(list);
      // 这里会多请求一次
      if (list.length === 0) {
        this.finished = true;
      }
    },
    // 需要分享的要向外发消息
    jump2article(item = {}) {
      const { address, title, imgUrl, id } = item;
      const { accessibilityType } = this.tabDetail;
      // const { userAgent } = navigator || {};
      // 记录访问次数
      this.$router.push({
        path: '/graphic/article',
        query: {
          url: encodeURIComponent(address),
          accessibilityType,
          title,
          imgUrl: encodeURIComponent(imgUrl),
          id
        }
      });
      // window.location.href = address;
      return;

      // // 点击文章的操作
      // if (/miniProgram/i.test(userAgent) || /wechatdevtools/i.test(userAgent)) {
      //   // 这个函数在小程序内有效
      //   window.wx.miniProgram.getEnv(res => {
      //     if (res.miniprogram) {
      //       if (accessibilityType === 1) {
      //         this.postFullPath();
      //         console.log('跳转article');
      //         window.wx.miniProgram.navigateTo({
      //           url: `/pages/index/article?id=${id}&url=${encodeURIComponent(
      //             address
      //           )}&title=${title}&imageUrl=${imgUrl}`
      //         });
      //       } else {
      //         console.log('跳转webview，不可分享');
      //         // 这里需要记录一下访问量
      //         this.recordVisitor(id).then(() => {
      //           window.location.href = address;
      //         });
      //       }
      //     }
      //   });
      // } else {
      //   console.log('非微信环境下的跳转');
      //   this.recordVisitor(id).then(() => {
      //     window.location.href = address;
      //   });
      // }
    },

    // 这里跳转之前记录一下当前的地址
    postFullPath() {
      if (!window.uni) {
        return;
      }
      console.log('this.$route', this.$route);
      let fullPath = window.location.href;
      const { active } = this;

      if (/active=/.test(fullPath)) {
        fullPath = fullPath.replace(/active=\d+/, `active=${active}`);
      } else {
        fullPath = `${fullPath}&active=${active}`;
      }

      window.uni.getEnv(function(res) {
        if (res.miniprogram) {
          window.uni.postMessage({
            data: {
              fullPath
            }
          });
        }
      });
    }
  }
};
</script>

